module.exports = __webpack_public_path__ + "media/applicants/icon-home-e7cc090d.png";